import Axios from '@/store/axios'
var Promise = require('bluebird')

  const initialState = () => ({
    id: null, // this is the client_id
    contact_id: null,
    user_id: null,
    first_name: null,
    last_name: null,
    email: null,
    address: null,
    city: null,
    state: null,
    zip: null,
    country: null
  });

  const state = initialState();
  const getters = {
    first_name: (state) => {
      if(state.first_name == null)
        return null
      else
        return state.first_name.charAt(0).toUpperCase() + state.first_name.slice(1);
    },
    last_name: (state) => {
      if(state.last_name == null)
        return null
      else
        return state.last_name.charAt(0).toUpperCase() + state.last_name.slice(1);
    },
    full_name: (state, getters) => {
      return getters.first_name + ' ' + getters.last_name
    },
    user_has_valid_billing_address: (state) => {
      if(state.address && state.city && state.state && state.zip && state.country)
        return true
      else
        return false
    },
    user_billing_address: (state) => {
      let billing_address = {}
      billing_address.address1 = state.address;
      billing_address.city = state.city;
      billing_address.state = state.state;
      billing_address.zip = state.zip;
      billing_address.country = state.country;
      return billing_address
    },
    minimal_required_user_object: (state) => { // this is used in the UPDATE_ACCOUNT_INFORMATION action to allow for easy patching
      return {
        first_name: state.first_name,
        last_name: state.last_name,
        email: state.email
      }
    }
  }
  const mutations = {
    SET_ACCOUNT_INFORMATION : ( state, account_information ) => {
      // Here we are iterating over each one of the keys in the new object and,
      // if it exists in the state, overwriting what currently exists
      Object.keys(account_information).forEach(function(key) {
        if (key in state) {
          state[key] = account_information[key];
        }
      });
      // address is named differently in Blesta than
      // what we name it so we need a special case for it
      if(account_information.address1)
        state.address = account_information.address1
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    }
  }
  const actions = {
    GET_ACCOUNT_INFORMATION : ( context, id ) => {
      return Promise.try( () => {
        return Axios.get(`/users/${id}`)
      }).then( (user_object) => {
        user_object.data.address = user_object.data.address1;
        delete user_object.data.address1
        context.commit('SET_ACCOUNT_INFORMATION', user_object.data)
        return
      })
    },
    UPDATE_ACCOUNT_INFORMATION : ( context, new_user ) => {
      return Promise.try( () => {
        let updated_user = context.getters.minimal_required_user_object;
        Object.keys(new_user).forEach( key => {
          updated_user[key] = new_user[key]
        });
        // address is named differently in Blesta than
        // what we name it so we need a special case for it
        if(updated_user.address) {
          updated_user.address1 = updated_user.address;
          delete updated_user.address
        }
        return Axios.patch(`/users/${context.state.id}`, updated_user )
      }).then( (new_user_response) => {
        return context.commit('SET_ACCOUNT_INFORMATION', new_user_response.data)
      })
    }
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
